document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu?.classList.toggle('is-open', !open);
  });

  const dial = document.querySelector('[data-dial]');
  if (dial) {
    const input = dial.querySelector('[data-dial-input]');
    const data = [
      { time: '08:00', period: 'Matin', dot: 'clear', title: 'Transparent — discret et polyvalent', url: '/collections/verres-transparents' },
      { time: '14:00', period: 'Journée', dot: 'yellow', title: 'Jaune — contraste et confort', url: '/collections/verres-jaunes' },
      { time: '20:00', period: 'Soirée', dot: 'orange', title: 'Orange — teinte plus enveloppante', url: '/collections/verres-oranges' },
      { time: '23:00', period: 'Nuit', dot: 'orange', title: 'Orange — pour la fin de journée', url: '/collections/verres-oranges' }
    ];
    const renderDial = () => {
      const item = data[Number(input.value)];
      dial.querySelector('[data-dial-time]').textContent = item.time;
      dial.querySelector('[data-dial-period]').textContent = item.period;
      const result = dial.querySelector('[data-dial-result]');
      result.innerHTML = `<span class="lens-dot ${item.dot}"></span><div><p>Notre suggestion</p><h3>${item.title}</h3><a href="${item.url}">Découvrir la collection →</a></div>`;
      input.style.setProperty('--progress', `${Number(input.value) / 3 * 100}%`);
    };
    input.addEventListener('input', renderDial);
    renderDial();
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const dots = [...gallery.querySelectorAll('[data-gallery-dots] button')];
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');

    function currentIndex() {
      const trackLeft = track.getBoundingClientRect().left;
      let closest = 0, closestDist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.getBoundingClientRect().left - trackLeft);
        if (d < closestDist) { closestDist = d; closest = i; }
      });
      return closest;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      slides[i].scrollIntoView({ behavior: 'instant', inline: 'start', block: 'nearest' });
    }
    function updateDots() {
      const i = currentIndex();
      dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
    }
    prevBtn?.addEventListener('click', () => goTo(currentIndex() - 1));
    nextBtn?.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 80);
    }, { passive: true });
  });

  document.querySelectorAll('[data-hero-spin]').forEach(hero => {
    const frames = [...hero.querySelectorAll('[data-hero-frame]')];
    if (frames.length < 2) return;
    let index = Math.max(0, frames.findIndex(f => f.classList.contains('is-active')));
    let timer;
    function show(i) {
      index = (i + frames.length) % frames.length;
      frames.forEach((f, idx) => f.classList.toggle('is-active', idx === index));
    }
    function play() { stop(); timer = setInterval(() => show(index + 1), 3500); }
    function stop() { clearInterval(timer); }

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', play);

    let startX = 0, dragging = false, dragged = false;
    const threshold = 45;
    hero.addEventListener('pointerdown', e => { dragging = true; dragged = false; startX = e.clientX; stop(); });
    hero.addEventListener('pointermove', e => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > threshold) { show(index + (dx < 0 ? 1 : -1)); startX = e.clientX; dragged = true; }
    });
    function endDrag() { if (dragging) { dragging = false; play(); } }
    hero.addEventListener('pointerup', endDrag);
    hero.addEventListener('pointerleave', endDrag);
    hero.addEventListener('click', e => { if (dragged) { e.preventDefault(); dragged = false; } });

    play();
  });

  document.querySelectorAll('[data-product-tiers]').forEach(group => {
    const qtyInput = group.closest('form')?.querySelector('[data-tier-quantity]');
    group.querySelectorAll('.product-tier').forEach(tier => {
      const radio = tier.querySelector('input[type="radio"]');
      radio.addEventListener('change', () => {
        group.querySelectorAll('.product-tier').forEach(t => t.classList.remove('is-selected'));
        tier.classList.add('is-selected');
        if (qtyInput) qtyInput.value = radio.dataset.tierQty;
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      select.closest('[data-product-root]')?.querySelector('[data-product-price]')?.replaceChildren(document.createTextNode(option.dataset.price));
    });
  });

  document.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-form-error]');
      button.disabled = true;
      error.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error((await response.json()).description || 'Ajout impossible');
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(r => r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          const link = el.closest('.cart-link');
          if (link) link.setAttribute('aria-label', `Panier, ${cart.item_count} article${cart.item_count !== 1 ? 's' : ''}`);
        });
        const toast = document.querySelector('[data-cart-toast]');
        toast?.classList.add('is-visible');
        setTimeout(() => toast?.classList.remove('is-visible'), 2600);
      } catch (err) { error.textContent = err.message; }
      finally { button.disabled = false; }
    });
  });
});
